import React, { useEffect, useState } from "react";
import { Flex, Heading, HStack, VStack, Stack, Text, Box, Image, Link, Spinner } from "@chakra-ui/react";
import { BiFilter } from "react-icons/bi";
import { GrFormDown } from "react-icons/gr";
import { useLocation, useParams } from "react-router-dom";
import CommonVars from "../components/CommonVars";
import LargeStarRating from "../components/LargeStarRatings";
import SmallStarRating from "../components/SmallStarRatings";
import axios from "axios";

function RatingFilterScreen() {
    const productid = parseInt(useParams().productid);
    const { search } = useLocation();
    const ratingNum = parseInt(search.split("=")[1]);
    const [avgRating, setAvgRating] = useState(0);
    const [totalReviews, setTotalReviews] = useState(0);
    const [reviews, setReviews] = useState('');
    const [loading, setLoading] = useState(false);

    // access backend to retrieve total and average rating
    const getReviewSummary = async () => {
        axios.get(`${CommonVars.API_URL}/product/${productid}/rating-summary?rating=${ratingNum}`)
        .then((res) => {
            setAvgRating(res.data[0].rating);
            setTotalReviews(res.data[0].totalreviews);
            setLoading(true)
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // access backend to retrieve reviews by rating
    const getReviewsByRating = async () => {
        axios.get(`${CommonVars.API_URL}/product/${productid}/reviews-rating?rating=${ratingNum}`)
        .then((res) => {
            if (res.data.length === 0) {
				window.location.replace('/no-review-filter');
			}
            setReviews(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        getReviewSummary();
        getReviewsByRating();
    });

    const pdtReviewsRating = [];
    for (let i=0; i < reviews.length; i++) {
        pdtReviewsRating.push(
            <Box
                key={reviews[i].review_id}
                bg="white"
                rounded="lg"
                shadow="sm"
                width={{ base: 'full', sm: 'xl', lg: '3xl' }}
                p={4}
            >
                <Box 
                    borderBottomWidth={1}
                    borderStyle={'solid'}
                    borderColor={'gray.200'}
                    pb={2}
                >
                    <HStack justify="space-between">
                        <Text fontWeight='semibold' color='#616161'>{reviews[i].username}</Text>
                        <Text color="grey">{reviews[i].date}</Text>
                    </HStack>
                </Box>
                <Box pt={2}>
                    <SmallStarRating rating={reviews[i].rating}/>
                    <Text pb={3} pt={1}>{reviews[i].review}</Text>
                    {
                        reviews[i].review_img_url !== "" ? 
                        <Box p={2} rounded='md' width={{sm: '40%', md: '29%', lg: '29%'}} bg={'#F4F4F4'}>
                            <Image boxSize='200px' borderRadius='md' objectFit='cover' src={reviews[i].review_img_url} alt={`Image of ${reviews[i].name}`}/>
                        </Box> : null
                    }
                </Box>
            </Box>
        )
    }

    return (
        <Flex 
            minH={'100vh'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            {loading !== true ? 
                <Flex align={'center'} justify={'center'}>
                    <VStack align="center">
                        <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                        <Text fontSize={18} pt={6}>Loading Reviews...</Text>
                    </VStack>
                </Flex> :
                <VStack pt={20} pb={8}>
                    <Stack align="center" pb={6}>
                        <Heading fontSize="xl">Customer Reviews</Heading>
                        <HStack>
                            <Text fontSize='5xl' fontWeight="bold">{avgRating}</Text>
                            <Text pt={6}>/ 5.0</Text>
                        </HStack>
                        <LargeStarRating rating={avgRating} />
                        <Link href={`/product/${productid}/reviews`}><Text>based on {totalReviews} review{totalReviews > 1 && 's'}</Text></Link>
                    </Stack>
                    <VStack>
                        
                    </VStack>
                    <VStack align="flex-start" spacing={3}>
                        <Box pb={1}>
                            <div className="dropdown">
                                <HStack>
                                    <BiFilter size={26} />
                                    <button className="dropbtn">Filter by ratings</button>
                                    <GrFormDown />
                                </HStack>
                                <div className="dropdown-content">
                                    <a href={`/product/${productid}/rating-search?rating=1`}>1 Stars</a>
                                    <a href={`/product/${productid}/rating-search?rating=2`}>2 Stars</a>
                                    <a href={`/product/${productid}/rating-search?rating=3`}>3 Stars</a>
                                    <a href={`/product/${productid}/rating-search?rating=4`}>4 Stars</a>
                                    <a href={`/product/${productid}/rating-search?rating=5`}>5 Stars</a>
                                    <a href={`/product/${productid}/reviews`}>View all</a>
                                </div>
                            </div>
                        </Box>
                        {pdtReviewsRating}
                    </VStack>
                </VStack>
            }
        </Flex>
    )
}

export default RatingFilterScreen;